<div class="form-group input-gplace">
  <input
    mdbInput
    jhiMarkAsterisk
    jhiGooglePlaces
    type="text"
    class="form-control"
    [placeholder]="placeholder"
    [id]="id"
    [mdbValidate]="true"
    [validateSuccess]="false"
    [formControl]="control"
    [class.unset-border-left]="direction === 'right'"
    [class.unset-border-right]="direction === 'left'"
    [class.unset-border-all]="direction === 'all'"
    [autocomplete]="'off'"
    [name]="id"
    [gplaceName]="id"
    (selectEvent)="setAddress($event)"
  />
  <mdb-error *ngIf="control && control.invalid && (control.dirty || control.touched) && verify">
    <span *ngIf="control.hasError('required')" jhiTranslate="ERROR.REQUIRED_FIELD"></span>
  </mdb-error>
  <!-- Gestion des erreurs de l'addressForm si et seulement si control est valid (pour éviter double message) -->
  <mdb-error id="addressFormSelect" *ngIf="addressForm.getAngularForm().invalid && (control.dirty || control.touched) && verify">
    <span jhiTranslate="components.gplace.incorrectAddress"></span>
  </mdb-error>
</div>
